const LoaderProfile = () => {
  return (
    <div className="spaceSection mt-5">
      <div className="boxProfile">
        <div className="containerImg">
          <div className="profilePicture animationLoader" />
        </div>
        <div className="containerInfo">
          <div>
            <div className="titleImg">
              <div className="w-28 h-3 animationLoader rounded-md" />
            </div>
            <div className="w-11 h-3 animationLoader rounded-md" />
          </div>
        </div>
      </div>
      <div className="minItems mr-5">
        <div className="labelItem" style={{ color: 'white' }}>
          Nombre de quien publica
        </div>
        <div className="boxItem er rounded-md"></div>
      </div>
      <div className="minItems">
        <div className="labelItem" style={{ color: 'white' }}>
          Cargo
        </div>
        <div className="boxItem animationLoader rounded-md"></div>
      </div>
    </div>
  );
};

export default LoaderProfile;
